function parseQueryString( queryString ) {
    var params = {}, queries, temp, i, l;
    queries = queryString.split("&");
    for ( i = 0, l = queries.length; i < l; i++ ) {
        temp = queries[i].split('=');
        params[temp[0]] = temp[1];
    }
    return params;
}

upstack.controller('developersCtrl', ['$window', 'MetaTags', '$rootScope', '$scope', function($window, MetaTags, $rootScope, $scope) {
	var vm = this;
	var query = $window.location.search;
	var data = {};
  vm.showTitle = false;

  vm.imgPath = 'https://d2fiffqdazudr2.cloudfront.net/img/partners/';
	vm.invision = {
    name: 'invision',
    color: '#ff3366',
    img: 'invision.png',
    video: 'invision-video.jpg',
    iframe: 'https://www.youtube.com/embed/wnr-K0L-Q0w?autoplay=1&showinfo=0&controls=0&hd=1&mute=1&loop=1&iv_load_policy=3',
    message: '“Upstack plays a key role in building the engineering team”',
    author: 'INVISION',
    position: '$230M raised',
    active: false,
    videoActive: false,
    zindex: 1,
    placeholder: 'public/img/invision-main-placeholder.jpg',
    placeholderWebp: 'public/img/invision-main-placeholder.webp'
  };

  vm.stopInvisionVideo = function() {
    vm.invision.videoActive = false;
    var video = document.querySelector('.invision-video video');
    video.pause();
    video.currentTime = 0;
  };

  vm.playInvisionVideo = function(key) {
    vm.invision.videoActive = true;
    document.querySelector('.invision-video video').play();
  };

  var pathname = $window.location.pathname;
	if(pathname.includes('developers') || pathname === '/') {
      $rootScope.metaTags = MetaTags;
      vm.query = {
          hdln: '',
          btn: '',
          campaign: '',
          para1_title: '',
          para1: ''
      };
      var query_cookies = Cookies.get('query');

      if(query.includes('?')) {
          data = parseQueryString(decodeURIComponent($window.location.search.split('?')[1]));
          Object.assign(vm.query, data);
          Cookies.remove('query');
          Cookies.set('query', JSON.stringify(vm.query));
      } else if(query_cookies) {
          data = JSON.parse(decodeURIComponent(query_cookies));
          Object.assign(vm.query, data);
      }

      if(vm.query.campaign) {
          $rootScope.metaTags.set(vm.query.campaign, true);
      }

      vm.showTitle = true;
  }
	
}]);
